
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/xrpl-blockchain-development",
      function () {
        return require("private-next-pages/services/xrpl-blockchain-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/xrpl-blockchain-development"])
      });
    }
  